export const PortfolioTypes = {
    SET_PORTFOLIO_DATA: 'SET_PORTFOLIO_DATA',
    SET_PORTFOLIO_IMAGES: 'SET_PORTFOLIO_IMAGES',
    SET_IS_DOWNLOADING: 'SET_IS_DOWNLOADING',
    SET_ADDED_IMAGES: 'SET_ADDED_IMAGES'
};